<template>
  <!-- 详细地址搜索框 -->
  <div>
         <mt-popup  v-model="popupVisible" position="bottom" class="g-bottom-popup" :closeOnClickModal="true">
    <div class="search-popup">
      <div class="popup-title">
        <span>详细地址</span>
        <i class="iconfont icon-icon_close icon-close"
          @click="popupVisible = false"></i>
        <!-- <img class="icon-close" @click="popupVisible = false" src="@/assets/images/close@2x.png"/> -->
      </div>
      <div class="top-search">
        <div class="search-input">
          <i class="iconfont icon-search" :class="PostUiIcon.search" />
          <input ref="addressInput"
                 id="addressInput"
                 v-model="searchText"
                 type="text"
                 placeholder="请输入需要搜索的详细地址"
                 autocomplete="off"
                 @input="handleAddressChange" @blur="formBlur">
          <i v-show="searchText"
             class="iconfont icon-close-circle"
             @click.stop="clearHandle()" />
        </div>
        <button v-if="searchText"
                type="button"
                class="btn-confirm"
                @click="onConfirm()">
          确定
        </button>
      </div>
      <!-- 搜索为空 和 刚打开 -->
      <div v-if="isNullList && !addressList.length" class="result-wrapping">
        <NoResultBox resultNull="暂无相关地址～"></NoResultBox>
      </div>
      <div v-if="!isNullList && !addressList.length" class="result-wrapping">
        <NoResultBox resultNull="搜索详细地址～" resultUrl="https://ump.ems.com.cn/newmail-resources/images/tips/mail-envelope-opened@3x.png"></NoResultBox>
      </div>
      <ul v-if="addressList.length" class="address-list">
        <li class="address-item" v-for="(item,index) in addressList" :key="index" @click="onSelectAddress(item)">
          <div class="addressInfo">
            <p class="address-title" v-html="highlightText(item.title, searchText)"></p>
            <p class="address-detail">{{item.address}}</p>
          </div>
        </li>
      </ul>
    </div>
  </mt-popup>
  <mt-popup
      v-model="isShowChange"
      position="center"
      class="change-popup"
      >
      <div class="comfirm-wrapper">
        <h1 class="title">提示</h1>
        <p class="comfirm-wrapper_tips">
          {{`详细地址与所选省市区不一致，`}}
        </p>
        <p class="comfirm-wrapper_tips">
          {{`是否切换到${changeAddress.areaAddress}？`}}
        </p>
        <div class="button-wrapper">
          <div class="button-wrapper_cancel" @click="handleCancelChange">重新输入</div>
          <div class="button-wrapper_comfirm" @click="comfirmChangeAddress">切换城市</div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import noAreaCity from '../../libs/noAreaCity.js'
import throttle from 'lodash.throttle'
import { Popup, Toast } from 'mint-ui'
import NoResultBox from '@/components/noResult/NoResultBox.vue' // 无结果
import { highlightText } from '@/plugin/commonUse.js'

export default {
  props: {
    address: {
      type: Object,
      default: () => {
        return {
          value: '',
          userProvince: '',
          userCity: '',
          userArea: '',
          userProvinceCode: '',
          userCityCode: '',
          userAreaCode: ''
        }
      }
    },
    search: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      isShowChange: false,
      popupVisible: false,
      timer: null, // 定时器
      selectAddress: {},
      searchText: '',
      isNullList: false,
      addressList: [], // 搜索出来的地址列表
      changeAddress: { // 改变城市的提示语
        cityAddress: '',
        areaAddress: ''
      }
    }
  },
  computed: {
    highlightText () {
      return highlightText
    }
  },
  mounted () {
  },
  components: {
    'mt-popup': Popup,
    NoResultBox
  },
  methods: {
    handleCancelChange () {
      this.isShowChange = false
    },
    comfirmChangeAddress () {
      this.isShowChange = false
      this.emitData()
    },
    clearHandle () {
      this.searchText = ''
      this.addressList = []
      this.isNullList = false
      this.selectAddress = {}
    },
    async onOpen () {
      this.$nextTick(() => {
        this.$refs.addressInput.focus()
      })
      this.addressList = []
      this.searchText = ''
      this.selectAddress = {}
      await this.searchAddress()
      this.popupVisible = true
    },
    handleAddressChange: throttle(function () {
      this.searchAddress()
    }, 650, {
      trailing: true,
      leading: false
    }),
    async searchAddress () {
      let region = ''
      let sortByArea = '' // 要置顶的区县
      if (!this.searchText) {
        return false
      }
      if (!this.address.userProvince) {
        // 没有选择省市区的，默认
        region = ''
      } else if (noAreaCity.includes(this.address.userCity)) {
        // 如果城市没有区，那么就传市
        region = this.address.userCity
        sortByArea = ''
      } else {
        region = this.address.userCity
        sortByArea = this.address.userArea
      }
      this.$fetch.post('getPlaceSuggestion',
        { keyword: this.searchText, region: region, sortByArea: sortByArea },
        'application/x-www-form-urlencoded;charset=UTF-8')
        .then(res => {
          if (res.data && res.data.code === '000000') {
            if (res.data.info.length > 0) {
              this.addressList = res.data.info
              this.isNullList = false
            } else {
              this.isNullList = true
              this.addressList = []
            }
          } else {
            this.popupVisible = true
            this.$toast(res.data.msg)
          }
        })
    },
    // 选择地址
    onSelectAddress (item) {
      this.selectAddress = item
      let { address = '', district = '', city = '', title = '' } = item
      // 拼接规则：有区，拿address区后面的字符，没区，拿address市后面的字符，再拼接title
      let c = ''
      if (address) {
        let a = address
        let b = ''
        if (district) {
          b = district
          if (a.indexOf(b) > 0) {
            c = a.substr(a.indexOf(b) + b.length)
          }
        } else if (!district && city) {
          b = city
          if (a.indexOf(b) > 0) {
            c = a.substr(a.indexOf(b) + b.length)
          }
        }
      }
      this.searchText = ''
      this.searchText = c + title // 拼接之后的详细地址
      this.onConfirm()
    },
    // 确定
    async onConfirm () {
      // 用户不选择搜索结果直接点击“确认”，为用户默认匹配本省市内匹配到搜索到第一个地址的区
      if (Object.keys(this.selectAddress).length === 0 && this.addressList.length > 0) {
        this.selectAddress = this.addressList[0]
      }
      // 原区县名称，原区县码
      let { userAreaCode } = this.address
      // 搜索得到的城市名称，区县名称， 区县码
      let { city = '', area = '', areaCode = '' } = this.selectAddress
      // 不能匹配到区的详细地址需要提示
      if (!areaCode && !area) {
        Toast({
          message: '未找到对应的省市区，请您手动进行选择！',
          className: 'address-toast'
        })
      }
      if (userAreaCode && areaCode && areaCode !== userAreaCode) {
        this.changeAddress.cityAddress = city
        this.changeAddress.areaAddress = area
        this.isShowChange = true
        // const action = await MessageBox({
        //   title: '提示',
        //   message: `详细地址与所选省市区不一致， 是否切换到${area}？`,
        //   confirmButtonText: '切换城市',
        //   cancelButtonText: '重新输入',
        //   showCancelButton: true,
        //   closeOnClickOverlay: true
        // })
        // if (action === 'confirm') {
        //   this.emitData()
        // }
        return false
      }
      this.emitData()
    },
    // 回传数据，关闭弹窗
    emitData () {
      this.popupVisible = false
      let address = {}
      if (this.selectAddress && this.selectAddress.adcode) {
        let { provinceCode, cityCode, areaCode, province = '', city = '', area = '', location = {} } = this.selectAddress
        address = {
          userProvinceCode: provinceCode,
          userCityCode: cityCode,
          userAreaCode: areaCode,
          userProvince: province,
          userCity: city,
          userArea: area,
          // value: province + city + area
          value: `${province}${city ? ' ' : ''}${city}${area && areaCode !== '010000F' ? ' ' + area : ''}`,
          location
        }
      } else {
        address = this.address
      }
      this.$emit('confirm', {
        addrInfo: {
          ...address
        },
        search: this.searchText.replace(/\s+/g, '') })
    },
    // 弹窗内的输入框失去焦点让页面恢复原位
    formBlur () {
      let element1 = document.getElementsByTagName('html')
      let element2 = document.getElementsByTagName('body')
      element1[0].scrollIntoView()
      element2[0].scrollIntoView()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./addressSearch.scss";
</style>
